import { Alert, Box, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { SELECTED_PRODUCTS_LIMIT } from 'domains/Catalog/Transfers/utils';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ProductSearcherFooterProps } from '../../ProductSearcher';

interface ProductSearcherConfirmTransferCardProps {
  footerProps: ProductSearcherFooterProps<false>;
}

export function ProductSearcherConfirmTransferCard({
  footerProps,
}: Readonly<ProductSearcherConfirmTransferCardProps>) {
  const tOrders = useTranslationOrders();
  const tCatalog = useTranslationCatalog();

  const totalProductsSelected = new Set(
    footerProps.selectedProducts.map((p) => p.productId),
  ).size;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="100%"
      gap="2-5"
    >
      {footerProps.selectedLimitReached && (
        <Alert appearance="warning">
          {tCatalog('transfers.new.selectedProductsLimitReached', {
            count: SELECTED_PRODUCTS_LIMIT,
          })}
        </Alert>
      )}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Text fontSize="caption">
          {totalProductsSelected > 0
            ? tOrders('productSearcher.searcherConfirm.selectedProductsCount', {
                count: totalProductsSelected,
              })
            : ''}
        </Text>
        <Box display="flex" alignItems="center">
          <CancelAndConfirmButtons
            onCancel={footerProps.onClose}
            onConfirm={footerProps.onSubmit}
            isConfirmDisabled={totalProductsSelected === 0}
            confirmText={tOrders('productSearcher.searcherConfirm.addConfirm')}
          />
        </Box>
      </Box>
    </Box>
  );
}
